import StorefrontIcon from '@mui/icons-material/Storefront';
import MarketplaceList from "./MarketplaceList";
import MarketplaceEdit from "./MarketplaceEdit";

export default {
    icon: StorefrontIcon,
    list: MarketplaceList,
    edit: MarketplaceEdit,
};
